import { Component, forwardRef, Input, ChangeDetectorRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { _HttpClient } from '@delon/theme';

import { SelectBaseComponent } from '../../select-base';

@Component({
  selector: 'app-da-acc-select',
  templateUrl: './da-account-select.component.html',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DepreciationAssetAccountSelectComponent),
      multi: true
    }
  ]
})
export class DepreciationAssetAccountSelectComponent extends SelectBaseComponent {
  constructor(http: _HttpClient, cdr: ChangeDetectorRef) {
    super(http, cdr);
  }

  @Input() labelType: 'code' | 'name' | 'full' = 'full';

  getLabel(item: any) {
    if (item) {
      if (this.labelType === 'code') return item.code;
      else if (this.labelType === 'name') return item.name;
      return `${item.code} - ${item.name}`;
    }
    return '';
  }

  getUrl(searchValue: string): string {
    let url = `api/ADAccountLinks/DaAccsLookup?$top=50&$skip=0&$orderby=code asc`;
    var filter = ``;
    if (searchValue) {
      const searchStr = searchValue.replaceAll("'", "''");
      filter = `contains(code, '${encodeURIComponent(
        searchStr
      )}') or contains(name,'${encodeURIComponent(searchStr)}')`;
    }
    if (filter) url = `${url}&$filter=${filter}`;

    return url;
  }
}
